import { alpha, CSSObject, styled as muiStyle } from "@mui/material/styles";
import { FormControlLabel, Checkbox, FormControlLabelProps } from '@mui/material';
import { CheckboxProps } from '../types';

export const StyledFormControlLabel = muiStyle(FormControlLabel)<FormControlLabelProps>(({ theme }) => ({
  margin: 0,
  '&>	.MuiFormControlLabel-label': {
    marginLeft: `8px`,
    fontSize: `14px`,
    letterSpacing: `-0.26px`,
  },
}));

const colorMixin = ({ theme, color }: any): CSSObject => ({
  ...(color && {
      borderColor: theme.palette[color].main,
  }),
  ...(color === 'default' && {
      borderColor: theme.palette.secondary.light,
    '&:hover': {
      backgroundColor:alpha(theme.palette.secondary.light, 0.08),
    },
  }),
});

export const StyledCheckbox = muiStyle(Checkbox, {
  shouldForwardProp: (prop) => !['allChecked'].includes(String(prop)),
})<CheckboxProps>(({ theme, color, disabled }) => ({
  position: `relative`,
  padding: `8px`,
  '&:hover': {
    backgroundColor:alpha(theme.palette.common.white, 0.08),
  },
  '&.Mui-disabled':{
    '&:before': {
      borderColor: alpha(theme.palette.common.white, 0.16),
    },
    '&.Mui-checked': {
      '&:after': {
        transform: `rotate(45deg) scale(1)`,
        borderColor: alpha(theme.palette.common.white, 0.48),
      },
    }
  },
  '&.Mui-checked': {
    '&:after': {
      transform: `rotate(45deg) scale(1)`,
    },
  },
  '&:before': {
    content: '""',
    display: `inline-block`,
    width: `16px`,
    height: `16px`,
    border: `2px solid ${theme.palette.secondary.light}`,
    boxSizing: `border-box`,
    borderRadius: `2px`,
    borderColor: alpha(theme.palette.common.white, 0.6),
    ...( color === `default` && {
      borderColor: theme.palette.secondary.light,
      backgroundColor: theme.palette.common.white,
      ...(disabled && {
        borderColor: alpha(theme.palette.secondary.light, 0.16),
      }),
    }),
    ...(disabled && {
      borderColor: alpha(theme.palette.secondary.light, 0.16),
    }),
  },
  '&:after': {
    content: '""',
    position: `absolute`,
    display: `inline-block`,
    width: `2.5px`,
    height: `6px`,
    transform: `rotate(45deg) scale(0)`,
    marginTop: `-2px`,
    borderBottomWidth: `2px`,
    borderRightWidth: `2px`,
    borderBottomStyle: `solid`,
    borderRightStyle: `solid`,
    borderColor: theme.palette.common.white,
    transition: `transform .2s linear`,
  },
  '&.MuiCheckbox-indeterminate': {
    '&:after': {
      height: `0` ,
      width: `6px`,
      marginTop: `0px`,
      transform: `rotate(0) scale(1)`
    },
  },
  svg:{
    display: `none`
  },

  ...(color === `default` && {
    '&:hover': {
      backgroundColor:alpha(theme.palette.secondary.main, 0.08),
    },
    '&.Mui-disabled':{
      '&:before': {
        borderColor: alpha(theme.palette.secondary.main, 0.16),
      },
      '&.Mui-checked': {
        '&:after': {
          transform: `rotate(45deg) scale(1)`,
          borderColor: alpha(theme.palette.secondary.main, 0.48),
        },
      }
    },
    '&.Mui-checked': {
      '&:after': {
        transform: `rotate(45deg) scale(1)`,
        borderColor: theme.palette.secondary.main,
      },
    },

    '&.MuiCheckbox-indeterminate': {
      '&:after': {
        height: `0` ,
        width: `6px`,
        marginTop: `0px`,
        transform: `rotate(0) scale(1)`,
        borderColor: theme.palette.secondary.main,
      },
    },
  }),
  // ...(color === `default` && { color: theme.palette.grayscaleSecondary[400] }),
  // ...(color === `primary` && { color: theme.palette.primary.main }),
  // ...(color === `secondary` && { color: theme.palette.secondary.main }),
  // ...(color === `error` && { color: theme.palette.error.main }),
  // ...(color === `info` && { color: theme.palette.info.main }),
  // ...(color === `success` && { color: theme.palette.success.main }),
  // ...(color === `warning` && { color: theme.palette.warning.main }),
  // ...(color === `grayscale` && {color: theme.palette.grayscale.main}),
  // ...(color && { color: theme.palette[color][400]}),

  ...(disabled && {
    'input[disabled]': {
      opacity: 0
    }
  }),
}));
export const StyledCheckedBox = muiStyle('div', {
  shouldForwardProp: (prop) => !['indeterminate', 'allChecked'].includes(String(prop)),
})<CheckboxProps>(({ theme, color, indeterminate }) => ({
  position: `relative`,
  // padding: `4.5px`,
  // '&:before': {
  //   content: '""',
  //   display: `block`,
  //   width:  `12px`,
  //   height:   `12px`,
  //   backgroundRepeat: `no-repeat`,
  //   backgroundPosition: `center center`,
  //   ...(color && { backgroundColor: theme.palette[color][400]}),
  //   ...(color == null || color === `inherit` && {backgroundColor:  alpha(theme.palette.common.white, 0.4)}),
  //   maskImage: `url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2.12 7.786 4.246 5.66 0 1.414 1.415 0l5.656 5.657L3.534 9.2z' transform='rotate(90 4.1 6.6)'/%3E%3C/svg%3E%0A")`,
  // },
  // '&:after': {
  //   content: '""',
  //   position: `absolute`,
  //   left:  `50%`,
  //   top: `50%`,
  //   transform: `translate(-50%,-50%)`,
  //   display: `block`,
  //   width: `16px`,
  //   height: `16px`,
  //   border: `2px solid `,
  //   boxSizing: `border-box`,
  //   borderRadius: `2px`,
  //   ...(color && { borderColor: theme.palette[color][400]}),
  // },

}));
